import React, { useEffect } from "react"
import Zoom from "react-medium-image-zoom"
import "react-medium-image-zoom/dist/styles.css"
import Image from "mui-image"
import { theme } from "themes/default/theme"
import { Dialog, useMediaQuery, Box } from "@mui/material"
import { masterBreakPoint } from "themes/default/breakpoints"
import {
  appbarHeight,
  appbarHeightMobile,
  footerHeightMobile,
  footerHeight,
} from "themes/constants/sizes"

export default function ImageZoom({ zoomEnabled = true, ...props }) {
  const compatible = "ResizeObserver" in window
  const WrapperComponent = zoomEnabled ? (compatible ? Zoom : Box) : Box
  const matches = useMediaQuery(masterBreakPoint)
  const [imageSource, setImageSource] = React.useState(props?.src)
  const [zoomOpen, setZoomOpen] = React.useState(false)

  useEffect(() => {
    setImageSource(props?.src)
  }, [props?.src])

  const onImageError = (e) => {
    setImageSource(require("assets/img/placeholder.png"))
    if (props?.onError) {
      props.onError(e)
    }
  }

  return (
    <WrapperComponent
      onClick={(evt) => {
        // evt.stopPropagation()
        if (!zoomEnabled) return
        setZoomOpen(!zoomOpen)
      }}
      {...((!zoomEnabled || !compatible) && {
        sx: {
          width: "100%",
          height: "100%",
          ...props.customWrapperStyle,
        },
      })}
    >
      <Dialog
        open={zoomOpen}
        onClose={(evt) => {
          evt.preventDefault()
          evt.stopPropagation()
          setZoomOpen(false)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        fullScreen
      >
        <Image
          fit="contain"
          duration={100}
          easing="ease-in"
          showLoading={false}
          errorIcon={require("assets/img/placeholder.png")}
          shift={null}
          distance="100px"
          shiftDuration={100}
          width={"100%"}
          height={"100%"}
          style={{
            width: "auto",
            height: "auto",
            maxWidth: "100%",
            maxHeight: `calc(90vh - 10px)`,
          }}
          sx={{
            borderRadius: theme.spacing(1.5),
            cursor: "zoom-out",
          }}
          src={imageSource || require("assets/img/placeholder.png")}
          onError={onImageError}
        />
      </Dialog>
      <Image
        fit="contain"
        duration={100}
        easing="ease-in"
        showLoading={false}
        errorIcon={require("assets/img/placeholder.png")}
        shift={null}
        distance="100px"
        shiftDuration={100}
        width={"100%"}
        height={"100%"}
        style={{
          width: "auto",
          height: "auto",
          maxWidth: "100%",
          maxHeight: `calc(calc(100vh - ${
            matches
              ? appbarHeightMobile + footerHeightMobile
              : appbarHeight + footerHeight
          }px) - 75px)`,
          minHeight: 150,
          ...props.customStyle,
        }}
        sx={{
          // TO DO define these styles to be used in a more general way
          borderRadius: theme.spacing(1.5),
          cursor: zoomEnabled && !compatible ? "zoom-in" : "default",
          ...props.customSx,
        }}
        {...props}
        src={imageSource || require("assets/img/placeholder.png")}
        onError={onImageError}
      />
    </WrapperComponent>
  )
}

// Path: src\components\UI\Zoom\index.js
